<div
    class="container-fluid well"
    data-test-automation="locality-and-lga">
    <h5>{{title}}</h5>

    <h6 class="required-input"> Localities </h6>
    <div class="row">
        <div class="form-group">
            @for (localityItem of getModel().localities; track localityItem; let i = $index) {
                <div
                    class="field-record col-xs-4"
                    data-test-automation="locality">
                    @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                        <div>
                            <div
                                class="input-group"
                                [ngClass]="{'has-error': (localityInput.invalid || localityInput.errors?.required ||isDuplicateLocality(i)|| !isValidLocality(i))
                            && localityInput.dirty}">
                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                <input
                                    type="text"
                                    id="locality{{i}}"
                                    [name]="'locality'+i"
                                    #localityInput="ngModel"
                                    ngDefaultControl
                                    class="form-control"
                                    placeholder="Enter to search"
                                    nlrFocus
                                    [(ngModel)]="getModel().localities[i].localityName"
                                    required
                                    [disabled]="isDisabled()"
                                    autocomplete="off"
                                    title="Search and select locality"
                                    [nlrTypehead]="filterLocalitiesByFullName"
                                    (itemSelected)="localitySelected($event)"
                                    data-test-automation="locality" />
                                @if (!isDisabled()) {
                                    <span class="input-group-addon">
                                        <i class="nlrp-icon nlrp-icon-search"></i>
                                    </span>
                                    @if (allowAdditionalLocalities()) {
                                        <span class="input-group-addon">
                                            <i
                                                class="nlrp-icon nlrp-icon-add"
                                                tabindex="0"
                                                (click)="addLocality()"
                                                title="Add a new locality"
                                                data-test-automation="add-locality"></i>
                                        </span>
                                    }
                                    @if (i > 0) {
                                        <span class="input-group-addon">
                                            <i
                                                class="nlrp-icon nlrp-icon-remove"
                                                tabindex="0"
                                                (click)="removeLocality(i)"
                                                title="Remove locality"
                                                data-test-automation="remove-locality"></i>
                                        </span>
                                    }
                                }
                            </div>
                            @if ((localityInput.errors?.required || !isValidLocality(i) ) && localityInput.dirty) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>No locality found.</span>
                                </div>
                            }
                            @if (isDuplicateLocality(i) && localityInput.dirty) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Locality has to be unique.</span>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
    <h6 class="required-input"> Local government authority </h6>
    <div class="row">
        <div class="form-group">
            @for (localGovernmentAuthority of getModel().localGovernmentAuthorities; track localGovernmentAuthority; let i = $index) {
                <div
                    class="field-record col-xs-4"
                    data-test-automation="lga">
                    @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                        <div>
                            <div
                                class="input-group"
                                [ngClass]="{'has-error':(lgaInput.invalid || lgaInput.errors?.required || isDuplicateLga(i) || !isValidLga(i))
                    && lgaInput.dirty}">
                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                <input
                                    type="text"
                                    id="lga{{i}}"
                                    #lgaInput="ngModel"
                                    [name]="'lga'+i"
                                    class="form-control"
                                    [(ngModel)]="getModel().localGovernmentAuthorities[i].lgaName"
                                    placeholder="Enter to search"
                                    nlrFocus
                                    required
                                    autocomplete="off"
                                    [nlrTypehead]="filterLgasByFullName"
                                    (itemSelected)="lgaSelected($event)"
                                    [disabled]="isDisabled()"
                                    title="Search and select local government"
                                    data-test-automation="lga" />
                                @if (!isDisabled()) {
                                    <span class="input-group-addon">
                                        <i class="nlrp-icon nlrp-icon-search"></i>
                                    </span>
                                    @if (allowAdditionalLgas()) {
                                        <span class="input-group-addon">
                                            <i
                                                class="nlrp-icon nlrp-icon-add"
                                                tabindex="0"
                                                (click)="addLga()"
                                                title="Add a new local government authority"
                                                data-test-automation="add-lga">
                                            </i>
                                        </span>
                                    }
                                    @if (i > 0) {
                                        <span class="input-group-addon">
                                            <i
                                                class="nlrp-icon nlrp-icon-remove"
                                                tabindex="0"
                                                (click)="removeLga(i)"
                                                title="Remove local government authority"
                                                data-test-automation="remove-lga">
                                            </i>
                                        </span>
                                    }
                                }
                            </div>
                            @if ((lgaInput.errors?.required || !isValidLga(i)) && lgaInput.dirty) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>No local government authority found.</span>
                                </div>
                            }
                            @if (isDuplicateLga(i) && lgaInput.dirty) {
                                <div class="help-block">
                                    <span>Error!</span>
                                    <span>Local government authority has to be unique.</span>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
<!--<div class="help-block">-->
<!--    <span>Error!</span>-->
<!--    <span>{{groups.planInformation.invalidLocalityAndLgaText}}</span>-->
<!--</div>-->
<!--</div>-->
